import React from "react";
import { Image } from "@chakra-ui/react";
import { SidebarButton } from "./SidebarButton";
import { SIDEBAR_ADMIN_BUTTON_CLICKED } from "api/analytics/events";
import dealsIcon from "screens/common/static/misc/deals_icon.svg";

export const SidebarDealFinder = () => {
  return (
    <SidebarButton
      text="Deal Finder"
      icon={<Image src={dealsIcon} boxSize="2rem" />}
      screen="deal-finder"
      analyticsEvent={SIDEBAR_ADMIN_BUTTON_CLICKED}
      cssClasses={["ch-sidebar-nav-deal-finder"]}
    />
  );
};
